import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {RiUser3Line} from "react-icons/ri";
import {
  sendVerificationEmail
} from "../../components/helpers/UserHelpers";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class SendEmailVerificationEmail extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);

    this.state = {
      email: ""
    }

    // createPaymentIntent("single_test", 500);

    // this.setState({songBookCount: songBookCount()});
  }

  componentDidMount() {
    if (sessionStorage.getItem("customer")) {
      sendVerificationEmail(JSON.parse(sessionStorage.getItem("customer")).user.id);
    }
  }

  onChangeEmail = (e) => {
    this.setState({
      email: e.target.value,
      emailError: "",
    });
  };

  resetButtonAvailable = () => {
    return (
        this.state.email
    );
  }

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  render() {
    return (
      <>
        <SeoHelper noindex={true} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>password reset</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-warning rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-planet" />*/}
                          {/*</div>*/}
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                <RiUser3Line color='#5e72e4' size="36"/>&nbsp;Verification email sent
                              </h2>
                              <p className="description mt-3">
                                {/*Sign in and build your curated song-flows*/}
                              </p>
                            </Col>
                          </Row>
                          <p className="description mt-3">
                            An email has been sent to your registered email address
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default SendEmailVerificationEmail;
